export enum GlobalClasses {
  hovered = 'hovered',
  hoveredChild = 'hoveredChild',
}
